<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Promotion code management</h1>
    <promotionListTable />
  </v-card>
</template>

<script>
import promotionListTable from "../../../../components/back-office/Promotion/PromotionListTable";
export default {
  components: {
    promotionListTable
  },
  destroyed() {
    this.$store.commit("fetchFoodPromotionBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Food delivery",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/food/promotion"
      },
      {
        text: "Promotion management",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
